// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root___8gid","left":"StickyBox_left__39iIw","right":"StickyBox_right__1lpgp"};